import { z } from 'zod';

export const loginSchema = z.object({
    username: z.string().nonempty(),
    password: z.string().nonempty(),
});
